module.exports = __webpack_public_path__ + "static/media/PICTo345.31907ee1.jpg";